<!--display logged in user details
In (ui) right upper corner, profile icon-> select the logged in user email
component used in RhsMenu.vue
-->
<template>
  <x-dialog
    width="50%"
    :dialogTitle="dialogTitle"
    :dialogState="showDialog"
    :dataTestId="dataTestId"
    @toggleModal="closeDialog"
  >
    <template slot="dialog_data">
      <loader v-if="contentLoading" />
      <v-card flat tile>
        <v-card-text>
          <v-tabs v-model="tab" slider-color="#58E2C2" :data-test-id="`${dataTestId}__tabs-wrapper`">
            <v-tabs-slider color="#58E2C2"></v-tabs-slider>
            <v-tab :key="1" :data-test-id="`${dataTestId}__basic-details-tab`">Basic details</v-tab>
            <!-- <v-tab :key="2">User status</v-tab> -->
            <v-tab :key="2" :data-test-id="`${dataTestId}__additional-details-tab`">Additional details</v-tab>
            <v-tab v-if="!hasSSOConsent" :key="3" :data-test-id="`${dataTestId}__change-password-tab`">Change password</v-tab>
            <v-tab :key="4" :data-test-id="`${dataTestId}__sessions-tab`">Sessions</v-tab>

            <v-tabs-items v-model="tab" class="pt-4">
              <basic-details :userDetails="userDetails"/>
              <additional-details :userDetails="userDetails"/>
              <change-password v-if="!hasSSOConsent" :userId="userDetails.userId" :data-test-id="`${dataTestId}__change-password-section`"/>
              <sessions :userId="userDetails.userId" :data-test-id="`${dataTestId}__sessions-section`"/>
            </v-tabs-items>
          </v-tabs>
        </v-card-text>
        <v-card-actions class="px-10 py-7">
          <v-row justify="end">
            <x-button
              outline
              color="#58E2C2"
              buttonText="Close"
              :dataTestId="`${dataTestId}__close-btn`"
              @click="closeDialog"
            />
            <v-spacer></v-spacer>
            <x-button
              v-if="tab !== 0"
              color="#58E2C2"
              buttonText=" Previous"
              :dataTestId="`${dataTestId}__previous-btn`"
              @click="prev"
            />
            <x-button
              v-if="showNextButton"
              color="#58E2C2"
              class="ml-2"
              buttonText=" Next"
              :dataTestId="`${dataTestId}__next-btn`"
              @click="next"
            />
          </v-row>
        </v-card-actions>
      </v-card>
    </template>
  </x-dialog>
</template>

<script>
import AdditionalDetails from './AdditionalDetails';
import BasicDetails from './BasicDetails.vue';
import ChangePassword from './ChangePassword.vue';
import Sessions from './Sessions.vue';
import { mapState } from 'vuex';

export default {
  components: { BasicDetails, AdditionalDetails, ChangePassword, Sessions },
  props: ['userDetailDialog', 'userDetails', 'currentTab'],
  computed: {
    ...mapState({
      hasSSOConsent: (state) => state?.singleSignOnStatus?.HAS_CONSENT,
    }),
    showNextButton() {
      // eslint-disable-next-line
      return !this.hasSSOConsent ? this.tab < 3 : this.tab < 2;
    },
  },
  data() {
    return {
      showDialog: false,
      dialogTitle: 'Profile details',
      tab: this.currentTab,
      contentLoading: true,
      dataTestId: 'profile-details-dialog'
    };
  },
  mounted() {
    this.showDialog = this.userDetailDialog;
    this.contentLoading = true;
    this.userDetails.license = this.userDetails.license.toLowerCase();
    this.contentLoading = false;
  },

  methods: {
    // escape key listener to close dialog when open

    // to close detail dialog
    closeDialog() {
      this.$emit('closeOverlay', true);
    },
    // to move to next tab
    next() {
      const tab_active = parseInt(this.tab);
      this.tab = tab_active + 1;
    },
    // to move to previous tab
    prev() {
      const tab_active = parseInt(this.tab);
      this.tab = tab_active - 1;
    },
  },
};
</script>

<style scoped>
.vue-tel-input:focus-within {
  border-color: transparent;
}
.is-invalid {
  border-color: red;
}
.is-valid {
  border-color: #58e2c2;
}
.show-password {
  background: rgb(229, 229, 229);
}
span  {
  font-size: 16px;
}

.active-session {
  color: #58e2c2;
}
.device-name {
  color: gray;
}
.session-date {
  columns: #414144;
}

.fname > div.v-input {
  padding-right: 10px !important;
}

.user-tab .v-tabs__container  {
  border-bottom: 1.5px solid rgba (27,  35,  66,  0.14);
}
.user-tab .v-tabs__div  {
  margin-right: 40px;
  font-size: 18px;
  line-height: initial;
  text-align: left;
  text-transform: capitalize;
}
.user-tab .v-tabs__item v-tabs__item--active  {
  font-weight: 600;
}
.user-tab .v-tabs__item  {
  padding-left: 0px;
  padding-right: 0px;
}
.user-tab  >  .v-toolbar__content  {
  padding: 0px !important;
}
.user-tab {
  box-shadow: none;
}

.customDialog .v-card .footerDialog {
  padding: 0;
}
</style>
